<template>
  <div class="content-box">
    <fieldset v-for="(external, i) in externals" :key="i">
      <legend>
        <span>External: {{ i }}</span>
      </legend>
      <v-row>
        <v-col cols="3"><p class="label">Component type</p></v-col>
        <v-col cols="2"><v-text-field :value="external.typestring" outlined dense hide-details readonly></v-text-field></v-col>
        <v-col cols="3"><p class="label">System ID.</p></v-col>
        <v-col cols="4"><v-text-field :value="external.systemid" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="3"><p class="label">Call time</p></v-col>
        <v-col cols="2"><v-text-field :value="external.calltime" outlined dense hide-details readonly></v-text-field></v-col>
        <v-col cols="3"><p class="label">Destination</p></v-col>
        <v-col cols="4"><v-text-field :value="external.destination" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="3"><p class="label">Connection counter</p></v-col>
        <v-col cols="2"><v-text-field :value="external.connectioncounter" outlined dense hide-details readonly></v-text-field></v-col>
        <v-col cols="3"><p class="label">Connection ID.</p></v-col>
        <v-col cols="4"><v-text-field :value="external.connectionid" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="3"><p class="label">Additional info.</p></v-col>
        <v-col cols="9"><v-text-field :value="external.addinfo" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import { api } from '../../../api/common/instances';
import tabable from './tabable';
export default {
  mixins: [tabable],
  data() {
    return {
      externals: [],
    };
  },
  methods: {
    async fetch(params) {
      // eslint-disable-next-line prettier/prettier
      ({ data: this.externals } = await api.get('/analysis/dsrviewer/detail/external', { params }));
      this.increaseLoadingCount();
    },
  },
};
</script>

<style lang="scss" scoped>
.content-box {
  padding: 0px;
}
fieldset {
  margin-top: 10px;
  padding: 10px;
  border-width: 1px;
}
fieldset legend {
  padding: 0px 10px;
}
.label {
  text-align: right;
  padding-right: 15px;
}
.v-text-field {
  width: 100%;
}
</style>
